<template>
  <nx-navigation-url
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      :value="value"
      v-validate="`nx_entity_url:${allowJsCalls}|required`"
      data-vv-validate-on="input"
      :error-messages="errorMessages"
      :required="required"
      :disabled="disabled"
      v-bind="$attrs"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
  ></nx-navigation-url>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NavigationUrl from '@/modules/navigation/components/NavigationUrl';

export default {
  name: 'nx-form-navigation-url',
  $_veeValidate: {
    validator: 'new', // give me a new vee-validate instance each time.
  },
  extends: {},
  mixins: [FormElement],
  components: {
    [NavigationUrl.name]: NavigationUrl,
  },
  props: {
    value: {
      type: Object,
    },
    allowJsCalls: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    onInput(url) {
      this.$parentForm.updateField(this.name, url);
      this.$emit('input', url);
    },
    onBlur($event) {
      this.flags.focused = false;
      this.$emit('blur', $event);
    },
  },
};
</script>
